import { Injector } from '@angular/core';
import { ServiceVariable } from '@wavemaker/variables';
import { WmsServiceVariableService } from '@wms/variables';

export class WmsServiceVariable extends ServiceVariable {
  serviceVariableService: WmsServiceVariableService;

  constructor(variable: any, private injector: Injector) {
    super(variable);
    this.serviceVariableService = this.injector.get(WmsServiceVariableService);
  }

  override invoke(options?: any, success?: any, error?: any) {
    // Not required to invoke service variables in studio.
    // Prefab scripts invoking service variables can cause errors.
    // In the future, if required to call super.invoke(), add below line of code before doing so
    // options = options || {};
    // options.skipNotification = true;
    // super.invoke(options, success, error);

    return Promise.resolve({});
  }

  __getVariableDependencies() {
    return this.serviceVariableService.__getVariableDependencies();
  }

  __onPropertyChange(propertyName: string, value?: any, initFlag?: any) {
    return this.serviceVariableService.__onPropertyChange(propertyName, value, initFlag);
  }

  __setServiceOperations(operations: any, selectedVariable: any, initFlag: any, serviceType: any) {
    return this.serviceVariableService.__setServiceOperations(operations, selectedVariable, initFlag, serviceType);
  }

  __prepareBindingObjectList(param: any, variable: any, oldBindings: any) {
    return this.serviceVariableService.__prepareBindingObjectList(param, variable, oldBindings);
  }

  __isBindingNotFromParam(nodeTarget: any) {
    return this.serviceVariableService.__isBindingNotFromParam(nodeTarget);
  }
}
